module.exports = __webpack_public_path__ + "static/media/mobile-testing.963d58df.svg";